import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { likewriterActions } from "_store";
import { Modal, Button } from 'react-bootstrap';
import axios from "axios";
import { history } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as mammoth from 'mammoth'; // For .docx parsing
import * as pdfjsLib from "pdfjs-dist/build/pdf.mjs";
pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
import { RTFJS } from 'rtf.js';
//import htmlDocx from 'html-docx-js';
export { MyWritingList };

function MyWritingList() {
  const dispatch = useDispatch();
  const { user: authUser } = useSelector((x) => x.auth);
  const { likewriter } = useSelector((x) => x.likewriter);
  const [file, setFile] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const { student } = useSelector((x) => x.student);
  const [correctedText, setCorrectedText] = useState("");
  const [errors, setErrors] = useState([]);
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [wordCount, setWordCount] = useState(0);
  const [sentenceCount, setSentenceCount] = useState(0);
  const [ grammarScore, setGrammarScore] = useState(0);
  const [ vocabularyScore, setVocabularyScore] = useState(0);
  const [ cohesionScore, setCohesion] = useState(0);
  const [ organizationScore, setOrganization] = useState(0);
  const [ contentScore, setContent] = useState(0);
  const [ grammarFeedback, setGrammarFeedback] = useState('');
  const [ vocabularyFeedback, setVocabularyFeedback] = useState('');
  const [ cohesionFeedback, setCohesionFeedback] = useState('');
  const [ organizationFeedback, setOrganizationFeedback] = useState('');
  const [ contentFeedback, setContentFeedback] = useState('');
  const [textInput, setTextInput] = useState("");
  const [lexileScore, setLexileScore] = useState(null);
  const YOUR_OPENAI_API_KEY = 'Bearer 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';
// Function to call API when user types in search box
const handleSearch = (e) => {
  const value = e.target.value;
  setSearchTerm(value);
  fetchEssays(value);
};

const sendToChatGPT = async (title, essay) => {
  if (!essay.trim()) {
    toast.error("File is empty or unreadable.");
    return;
  }

  const response = await axios.post(
    "https://api.openai.com/v1/chat/completions",
    {
      model: "gpt-4o",
      messages: [
        {
          role: "user",
          content: `Evaluate the following essay:
          ${essay}
  
          Provide a JSON response with:
    - Content & Ideas (score out of 100 + feedback)
    - Organization (score out of 100 + feedback)
    - Grammar & Mechanics (score out of 100 + feedback)
    - Vocabulary Use (score out of 100 + feedback)
    - Coherence & Cohesion (score out of 100 + feedback)
    - Total Score (out of 100)
    - Corrected text
    - Errors (list of wrong words and suggestions)
    - Grammar punctuation score (0-100)
    - Vocabulary score (0-100)
    - Character count, word count, and sentence count.
    - **Lexile Score** (a numerical value estimating the reading difficulty level)

    Ensure all scores are out of 100. Respond in JSON format only (no explanations, no markdown).`,
        },
      ],
      temperature: 0,
      top_p: 0,
          seed: 1234
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: YOUR_OPENAI_API_KEY,
      },
    }
  );
  
  // Clean the response by removing any triple backticks and unnecessary formatting
  let responseDataText = response.data.choices[0].message.content.trim();
  responseDataText = responseDataText.replace(/```json|```/g, "").trim();
 

  const responseData = JSON.parse(responseDataText);
  // Extract and rename the fields
const {
"Lexile Score": lexile_score, // Add this line
"Content & Ideas": content_ideas,
"Organization": organization,
"Grammar & Mechanics": grammar_mechanics,
"Vocabulary Use": vocabulary_use,
"Coherence & Cohesion": coherence_cohesion,
"Total Score": total_score,
"Corrected text": corrected_text,
"Errors": errors,
"Character count": character_count,
"Word count": word_count,
"Sentence count": sentence_count,
} = responseData;
setLexileScore(lexile_score);
  setCorrectedText(corrected_text);
  setErrors(errors);
  setScore(total_score);
  setCharCount(character_count);
  setWordCount(word_count);
  setSentenceCount(sentence_count);
  setGrammarScore(grammar_mechanics.score);
  setVocabularyScore(vocabulary_use.score);
  setContent(content_ideas.score);
  setOrganization(organization.score);
  setCohesion(coherence_cohesion.score);
  setGrammarFeedback(grammar_mechanics.feedback);
  setVocabularyFeedback(vocabulary_use.feedback);
  setContentFeedback(content_ideas.feedback);
  setOrganizationFeedback(organization.feedback);
  setCohesionFeedback(coherence_cohesion.feedback);
   var student_id = authUser.user.student_id;
   var teacher_id = authUser.user.teacher_id;
  //  var title = title;
  //  var essay = essay;
  var response1 =  dispatch(likewriterActions.createEssay({ student_id, teacher_id,title,essay,character_count, word_count,sentence_count,vocabulary_use: JSON.stringify(vocabulary_use) ,corrected_text,errors: JSON.stringify(errors),content:JSON.stringify(content_ideas), organization: JSON.stringify(organization),grammar_mechanics:JSON.stringify(grammar_mechanics),coherence_cohesion:JSON.stringify(coherence_cohesion),total_score,lexile_score }))
.then((response2) => {
  console.log("Response:", response2.payload.data.id);

  if (response2?.payload?.data?.id) {
    history.navigate('/essay/'+response2?.payload?.data?.id);
   // window.location.href = '/essay/'+response2?.payload?.data?.id;
    toast.success("Essay created successfully!");
  } else {
    toast.error("Failed to create essay.");
  }
})
.catch((error) => {
  console.error("Error creating essay:", error);
  toast.error("An error occurred.");
});;

};

// API Call to fetch essays based on search term
const fetchEssays = (query) => {
  if (authUser) {
    const student_id = authUser.user.student_id;
    const teacher_id = authUser.user.teacher_id;
    const title = query;
    if (student_id) {
      dispatch(likewriterActions.searchEssayByTitle({ student_id, title }));
    } else {
      dispatch(likewriterActions.searchEssayByTitle({ teacher_id, title }));
    }
  }
};

  const handleDownload = (fileUrl) => {
    const fileName = 'recording.mp3'; // Replace with your desired file name

    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
  };
  const truncateText = (text, wordLimit) => {
    const truncatedText = text.length > wordLimit ? text.substring(0, wordLimit) + "..." : text;
    return truncatedText;
  };
  useEffect(() => {
    if (!authUser){
      toast.error('Please login to view this page.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        });
      history.navigate('/login');
    }else{
      var student_id = authUser.user.student_id;
      var teacher_id = authUser.user.teacher_id;
      if(student_id){
        dispatch(likewriterActions.getEssayListByStudentId({ student_id }));
      }else{
        dispatch(likewriterActions.getEssayListByTeacherId({ teacher_id }));
      }
       
    }

  }, []);

  const [showDialog, setShowDialog] = useState(false);
  //console.log(likewriter,'get likewrtier');return false;
  const handleDelete = (record_id) => {
    // Show the dialog when delete action is clicked
    setShowDialog(true);
  };

  const handleCancel = () => {
    // Hide the dialog when cancel action is clicked
    setShowDialog(false);
  };

  const handleConfirmDelete = async(essay_id) => {
    // Handle the deletion here
    console.log('Deleting...', essay_id);
   
     // Hide the dialog after deletion
    setShowDialog(false);
     // Call your deletePlan function here
  return  dispatch(likewriterActions.deleteEssayById({ essay_id }));
 
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
  
    const fileType = file.name.split('.').pop().toLowerCase();
  
    if (fileType === 'txt') {
      readTxtFile(file);
    } else if (fileType === 'docx') {
      readDocxFile(file);
    } else if (fileType === 'pdf') {
      readPdfFile(file);
    }  else if (fileType === 'doc') {
      readDocFile(file);
    }else if (fileType === 'rtf') {
      readRtfFile(file);
    }  else {
      toast.error("Unsupported file format. Upload .txt, .docx, or .pdf.");
    }
  };
  
  // Function to extract title & essay
  const extractTitleAndEssay = (text,type) => {

    if(type == 'RTF'){
      // Ensure text has proper spacing
      text = text.replace(/([a-z])([A-Z])/g, '$1\n$2'); // Add a newline before capitalized words if needed
      console.log(text, 'Formatted Text with Line Breaks');
    }
    
    const lines = text.split("\n").map(line => line.trim()).filter(line => line);
    const title = lines.length > 0 ? lines[0] : "Untitled Essay";
    const essay = lines.slice(1).join("\n").trim();
    return { title, essay };
  };
  
  // Read .txt files
  const readTxtFile = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      const { title, essay } = extractTitleAndEssay(text);
      sendToChatGPT(title, essay);
    };
    reader.readAsText(file);
  };
  
  const readDocxFile = (file) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const arrayBuffer = event.target.result;
        const result = await mammoth.extractRawText({ arrayBuffer });
  
        const text = result.value.trim(); // Ensure no leading/trailing spaces
        const { title, essay } = extractTitleAndEssay(text);
  
        console.log("Title:", title);
        console.log("Essay:", essay);
  
        sendToChatGPT(title, essay);
      } catch (error) {
        console.error("Error reading .docx:", error);
        toast.error("Error reading .docx file.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const readPdfFile = (file) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const typedArray = new Uint8Array(event.target.result);
        const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;
  
        let text = "";
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const content = await page.getTextContent();
          const pageText = content.items.map((item) => item.str).join("\n");
          console.log(`Page ${i} Text:`, pageText); // Debug log
          text += pageText + "\n";
        }

        if (!text.trim()) {
          throw new Error("PDF appears to be empty or unreadable.");
        }
  
        const { title, essay } = extractTitleAndEssay(text);
        console.log(extractTitleAndEssay(text),'get text');
        sendToChatGPT(title, essay);
      } catch (error) {
        console.error("Error reading PDF:", error);
        toast.error("Error reading .pdf file. Ensure it's a valid document.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const readDocFile = async (file) => {
    const reader = new FileReader();
  
    reader.onload = async (event) => {
      try {
        const arrayBuffer = event.target.result;
  
        // ✅ Check if file is `.doc` (not `.docx`)
        if (file.name.endsWith(".doc")) {
          toast.error("Cannot directly read .doc files. Convert to .docx and retry.");
          return;
        }
  
        // ✅ Extract text from `.docx` file
        const result = await mammoth.extractRawText({ arrayBuffer });
        const text = result.value.trim();
  
        if (!text) throw new Error("File appears to be empty.");
  
        // ✅ Extract title & essay
        const { title, essay } = extractTitleAndEssay(text);
        sendToChatGPT(title, essay);
  
      } catch (error) {
        console.error("Error reading .doc file:", error);
        toast.error("Error reading .doc file. Convert it to .docx and try again.");
      }
    };
  
    reader.readAsArrayBuffer(file);
  };
  

  
  // const readRtfFile = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = async (event) => {
  //     try {
  //       const arrayBuffer = event.target.result;
  //       const result = await mammoth.extractRawText({ arrayBuffer });
  
  //       const text = result.value.trim(); // Ensure no leading/trailing spaces
  //       if (!text) throw new Error("RTF file is empty or unreadable.");
  
  //       const { title, essay } = extractTitleAndEssay(text);
  //       sendToChatGPT(title, essay);
  //     } catch (error) {
  //       console.error("Error reading RTF:", error);
  //       toast.error("Error reading RTF file.");
  //     }
  //   };
  //   reader.readAsArrayBuffer(file);
  // };

  const readRtfFile = async (file) => {
    const reader = new FileReader();

    reader.onload = (event) => {
        try {
            const arrayBuffer = event.target.result;
            const decoder = new TextDecoder("utf-8"); // Decode binary to text
            let rtfContent = decoder.decode(arrayBuffer);

            let cleanedText = rtfContent
            .replace(/^{\\rtf1[^\n]*\n?/, '')  // Remove everything from "{\rtf1" to the first newline
            .replace(/}$/, '')                // Remove the closing bracket at the end
            .replace(/\\[a-z]+\d*/g, '')      // Remove control words like "\par", "\b0", etc.
            .replace(/{\\[^}]+}/g, '')        // Remove grouped RTF content
            .replace(/[{}\r\n]/g, '')         // Remove extra brackets and newlines
            .trim(); // Trim whitespace

console.log(cleanedText,'rtfContent');
            // Extract plain text by removing RTF formatting
            // let text = rtfContent
            //     .replace(/\\[a-z]+\d*/g, '')  // Remove commands (\par, \b, etc.)
            //     .replace(/{\\[^}]+}/g, '')    // Remove grouped RTF content
            //     .replace(/[{}\r\n]/g, '')     // Remove brackets and line breaks
            //     .trim();
            //     console.log(text,'text');
            //if (!text) throw new Error("RTF file is empty or unreadable.");

            const { title, essay } = extractTitleAndEssay(cleanedText,'RTF');
            console.log(title, essay,'get title essay');
            sendToChatGPT(title, essay);
        } catch (error) {
            console.error("Error reading RTF:", error);
            toast.error("Error reading RTF file.");
        }
    };

    reader.readAsArrayBuffer(file); // Read the file as a binary buffer
};




  return (
    <section className="custom-sign">
    <div className="container">
	<div className="my-writing-list">
		<h2 className="list-head">My Writing List</h2>
      <div className="row">
	  
        <div className="col-md-12">
		      <label>Search</label>
  
        <input type="text" placeholder="Search" value={searchTerm} onChange={handleSearch} />
          </div>
          <div className="col-md-2">
          <a href="/essay/index"><p className="new-file-div">New File</p></a>
          <input type="file" accept=".txt,.docx,.pdf,.rtf,.doc" onChange={handleFileUpload} />
          </div>
          <div className="col-md-10">
          {(likewriter && likewriter.data.length > 0) ? likewriter.data.map((essay, index) => ( 

            <div className="position-relative">
            <a href={`/essay/${essay.id}`}>
            <div className='essay-title'>{essay.title}</div>

            <div className='essay-text'>{truncateText(essay.essay, 15)}</div>
           
            </a>
              <div className="overlay">
             <p>{JSON.parse(essay.errors).length} Grammar</p>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(essay.id)}
                >
                  <i className="fa fa-trash"></i>
                </button>
                <Modal show={showDialog} onHide={handleCancel}>
                <Modal.Header closeButton>
                  <Modal.Title>Delete Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this?</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                  </Button>
                  <Button variant="danger" onClick={() => handleConfirmDelete(essay.id)}>
                    Delete
                  </Button>
                </Modal.Footer>
              </Modal>
                
              </div>
            </div>
          )): <p className='no-record-div'>No Records Found.</p>}

     
        </div>
      </div>
    </div>
  </div>

</section>
    )
}
